import React, { useEffect, useState } from 'react';

import Text from '@amzn/meridian/text';
import Column from '@amzn/meridian/column';
import type { AssociateProfilePlacementsResponse } from 'src/services/associateProfile/types';
import PendingPlacementCard from './pendingPlacementCard';
import TransferredInPlacementCard from './transferredInPlacementCard';
import ActivePlacementCard from './activePlacementCard';
import associateProfileService from 'src/services/associateProfile/associateProfileService';
import { useAppSelector } from 'src/store/store';
import { useParams } from 'react-router-dom';

const DEFAULT_PLACEMENT_STATE: AssociateProfilePlacementsResponse = {
  pending: [],
  active: [],
  transferredIn: [],
};

const AssociateProfilePlacements = () => {
  const { alias } = useParams();
  const { selectedSite } = useAppSelector((state) => state.sites);
  const [placements, setPlacements] = useState(DEFAULT_PLACEMENT_STATE);
  useEffect(() => {
    const fetchAssociateProfilePlacements = async () => {
      if (!alias || selectedSite.id === 0) {
        return;
      }

      try {
        const { data } = await associateProfileService.getAssociateProfilePlacements(alias, selectedSite.id);
        setPlacements(data);
      } catch (e) {
        setPlacements(DEFAULT_PLACEMENT_STATE);
      }
    };

    fetchAssociateProfilePlacements();
  }, [alias, selectedSite.id]);

  return (
    <Column spacing="400">
      <Text type="b500">Placements Pending Action ({placements.pending.length})</Text>
      {placements.pending.map((placement) => (
        <PendingPlacementCard key={placement.accommodationId} placement={placement} />
      ))}
      {placements.transferredIn.map((placement) => (
        <TransferredInPlacementCard key={placement.accommodationId} placement={placement} />
      ))}
      <Text type="b500">Active Placements ({placements.active.length})</Text>
      {placements.active.map((placement) => (
        <ActivePlacementCard key={placement.accommodationId} placement={placement} />
      ))}
    </Column>
  );
};

export default AssociateProfilePlacements;
